import React from 'react'

function TestMic() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className="mt-0.5"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M12.667 6.667V8A4.667 4.667 0 018 12.667m0 0A4.666 4.666 0 013.333 8V6.667m4.667 6v2.666m-2.667 0h5.334M8 .667a2 2 0 00-2 2V8a2 2 0 104 0V2.667a2 2 0 00-2-2z"
      ></path>
    </svg>
  )
}

export default TestMic
